import { FEATURE_ENUM } from '@partoohub/api-client';

import { useHasBusinessWithFeature } from 'app/common/hooks/accessesAndPermissions/businessSubcriptions/useHasBusinessWithFeature';
import { useHasFeature } from 'app/common/hooks/accessesAndPermissions/pages/useHasFeature';

export enum CEOrgFeatures {
    RB = 'RB',
    RM = 'RM',
    FeedbackManagement = 'FeedbackManagement', // Base FBM org feature
    DownloadFBM = 'DownloadFBM',
    FBMReplySuggestion = 'FBMReplySuggestion',
    AutoReplyWithoutComments = 'AutoReplyWithoutComments',
    AutoReplyWithComments = 'AutoReplyWithComments',
}

export const useHasCEOrgFeatures = (): {
    orgFeatures: Record<CEOrgFeatures, boolean | undefined>;
    isLoading: boolean;
} => {
    const subscribedToRB = useHasBusinessWithFeature(FEATURE_ENUM.REVIEW_INVITE);
    const subscribedToRM = useHasBusinessWithFeature(FEATURE_ENUM.REVIEW_MANAGEMENT);

    const hasFeedbackManagement = useHasFeature(FEATURE_ENUM.FEEDBACK_MANAGEMENT);
    const hasDownloadFBM = useHasFeature(FEATURE_ENUM.FEEDBACK_MANAGEMENT_DOWNLOAD);
    const hasFBMReplySuggestion = useHasFeature(FEATURE_ENUM.FEEDBACK_MANAGEMENT_REPLY_SUGGESTION);
    const hasAutoReplyWithoutComments = useHasFeature(
        FEATURE_ENUM.REVIEW_AUTO_REPLY_WITHOUT_COMMENTS,
    );
    const hasAutoReplyWithComments = useHasFeature(FEATURE_ENUM.REVIEW_AUTO_REPLY_WITH_COMMENTS);

    return {
        orgFeatures: {
            [CEOrgFeatures.RB]: subscribedToRB,
            [CEOrgFeatures.RM]: subscribedToRM,
            [CEOrgFeatures.FeedbackManagement]: hasFeedbackManagement,
            [CEOrgFeatures.DownloadFBM]: hasDownloadFBM,
            [CEOrgFeatures.FBMReplySuggestion]: hasFBMReplySuggestion,
            [CEOrgFeatures.AutoReplyWithoutComments]: hasAutoReplyWithoutComments,
            [CEOrgFeatures.AutoReplyWithComments]: hasAutoReplyWithComments,
        },
        // TODO RICK: clean up this isLoading logic
        isLoading: false,
    };
};
